<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mrp/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('MRPdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('MRPzhuangtai')">
            <yi_dictionary_select :max="999" multiple clearable="false" type="MRP_HEAD_STATUS" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_wms_mrp_order_create')" :loading="loading" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button :loading="loading" size="mini" @click="getSync">
          {{ $t('huoquMRPshuju') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-button v-if="utils.checkPower('web_wms_mrp_order_shortageCalc')" type="text" @click="shortage(scope.row)">{{ $t('queliaojisuan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mingxi', scope.row, '80%')">{{ $t('mingxi') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-button v-if="utils.checkPower('web_wms_mrp_order_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/mrp/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jihuadanhao')" required>
            <el-select v-model="selectedPlan" value-key="id" :placeholder="$t('qingxuanze')" clearable filterable @change="planChange">
              <el-option v-for="item in planList" :key="item.id" :label="item.no" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma')" required>
            <el-input :value="selectedPlan.material && selectedPlan.material.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')" required>
            <el-input :value="selectedPlan.material && selectedPlan.material.name" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuashuliang')" required>
            <el-input :value="selectedPlan.quantity" disabled></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/mrp/create', beforeCreate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--缺料计算-->
      <template v-if="yt.editObj.action == 'queliaojisuan'">
        <div class="dialog-scroller">
          <shortage_calculation ref="calculationOrder" :calculation="yt.editObj"></shortage_calculation>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="saveCalculationLoading" size="mini" @click="saveCalculation" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--明细-->
      <template v-if="yt.editObj.action == 'mingxi'">
        <div class="dialog-scroller">
          <mrp_details :mrpOrder="yt.editObj"></mrp_details>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import mrp_details from './mrp_details/index.vue';
import shortage_calculation from './mrp_details/shortage_calculation.vue';
export default {
  name: 'web_wms_mrp_order_list',
  components: {
    mrp_details,
    shortage_calculation
  },
  data() {
    return {
      loading: false,
      saveCalculationLoading: false,
      calculationId: null,
      list: [],
      planList: [],
      selectedPlan: {},
      columns: [
        {
          label: 'MRPdanhao',
          prop: 'no'
        },
        {
          label: 'jihuadanhao',
          prop: 'planNo'
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity'
        },
        {
          label: 'MRPzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'MRP_HEAD_STATUS'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action == 'mingxi' && n == false) {
          this.yt.get();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },

  methods: {
    // 保存新增之前处理参数
    beforeCreate(params) {
      const obj = {
        planNo: this.selectedPlan.no
      }
      return obj;
    },
    // 新增弹窗之前处理数据
    beforeShowEditDialogInsert(row) {
      this.getPlanList();
      return row;
    },
    // 获取计划单列表
    getPlanList() {
      this.http
        .get('/web/production/plan/info/list')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.planList = res.data;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 选择计划单是调用
    planChange(v) {
      this.selectedPlan = v;
      console.log('sssss', v);
    },
    // 同步获取mrp数据
    getSync() {
      this.loading = true;
      return this.http
        .post('/web/mrp/sync')
        .then(response => {
          this.yt.get();
          this.utils.successMessage(this.$t(response.msg));
          this.loading = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.loading = false;
        });
    },
    shortage(row) {
      this.yt.showEditDialog('queliaojisuan', row, '80%');
      this.calculationId = row.id;
    },
    // 缺料计算
    saveCalculation() {
      this.saveCalculationLoading = true;
      let ids = this.$refs['calculationOrder'].ids;
      if (ids !== null) {
        let params = {
          warehouseIds: ids,
          id: this.calculationId
        };
        return this.http
          .post('/web/mrp/shortageCalc', params)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get();
            this.saveCalculationLoading = false;
          })
          .catch(error => {
            this.$message.error(error);
            this.saveCalculationLoading = false;
          });
      } else {
        this.$message.error(this.$t('qinggouxuanshuju'));
      }
    }
  }
};
</script>
